var map = {
	"./ar/menu.json": "./src/locales/ar/menu.json",
	"./cz/menu.json": "./src/locales/cz/menu.json",
	"./de/menu.json": "./src/locales/de/menu.json",
	"./en/menu.json": "./src/locales/en/menu.json",
	"./es/menu.json": "./src/locales/es/menu.json",
	"./fr/menu.json": "./src/locales/fr/menu.json",
	"./hr/menu.json": "./src/locales/hr/menu.json",
	"./ja/menu.json": "./src/locales/ja/menu.json",
	"./ko/menu.json": "./src/locales/ko/menu.json",
	"./kz/menu.json": "./src/locales/kz/menu.json",
	"./pt/menu.json": "./src/locales/pt/menu.json",
	"./sh/menu.json": "./src/locales/sh/menu.json",
	"./sr/menu.json": "./src/locales/sr/menu.json",
	"./sv/menu.json": "./src/locales/sv/menu.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive ^\\.\\/.*\\/menu\\.json$";